<template>
  <article class="subscriber">
    <div
      class="subscriber__header"
      :style="
        backgroundImageUrl &&
          `background-image: url(${backgroundImageUrl}), linear-gradient(to bottom, #1A1215 0%, rgba(26, 18, 21, 0) 100%); background-size: cover;`
      "
    >
      <div class="lphero__overlay subscriber__header-overlay"></div>
      <ResumeFromRecentActivity
        v-bind="{
          learningPath,
          course,
          learningArea,
          instructor,
          nextUpTypeAndId,
          nextUpContent,
          learningPathBackground,
          isTablet,
        }"
      />
      <SectionalLearningPathCarousel
        v-if="isResumingLearningPath"
        :learningPathId="learningPath.id"
        :targetCourseId="course && course.id ? course.id : ''"
        :isMobile="isMobile"
        :isTablet="isTablet"
      />
    </div>
    <RecentlyActive
      v-if="otherRecentActivity && otherRecentActivity.length"
      :courses="otherRecentActivity"
      :isTablet="isTablet"
    />
    <MetricCarousel
      v-for="metric in carouselMetrics"
      :key="`metric-${metric.name}-${metric.facet}`"
      :algoliaKeys="algoliaKeys"
      :metric="metric"
      :isTablet="isTablet"
      :isMobile="isMobile"
      :activeCourses="activeCourses"
    />
    <div class="subscriber__tags-carousel-wrapper">
      <CarouselsByTags
        :isMobile="isMobile"
        :algoliaKeys="algoliaKeys"
        :isFreeTrialUser="isFreeTrialUser"
      />
    </div>
  </article>
</template>

<script>
import { mapState } from 'vuex'
import { getBackgroundSizeBaseOnBreakpoint } from '@/helpers'
import ResumeFromRecentActivity from '@/components/home/subscriber-view/ResumeFromRecentActivity.vue'
import SectionalLearningPathCarousel from '@/components/home/subscriber-view/SectionalLearningPathCarousel.vue'
import RecentlyActive from '@/components/home/subscriber-view/RecentlyActive.vue'
import MetricCarousel from '@/components/home/MetricCarousel.vue'
import CarouselsByTags from '@/components/home/anonymous-view/CarouselsByTags.vue'

export default {
  name: 'SubscriberView',
  inject: ['getBreakpoint'],
  components: {
    ResumeFromRecentActivity,
    SectionalLearningPathCarousel,
    RecentlyActive,
    MetricCarousel,
    CarouselsByTags,
  },
  props: {
    algoliaKeys: {
      type: Object,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    isTablet: {
      type: Boolean,
      required: true,
    },
    carouselMetrics: {
      type: Array,
      required: true,
    },
    recentActivity: {
      type: Object,
      required: true,
    },
    nextUpContent: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      isFeaturedBootcampShown: false,
    }
  },
  computed: {
    ...mapState({
      activeCourses: state => state.courses.activeCourses,
    }),
    otherRecentActivity() {
      const { other_recent_courses } = this.recentActivity
      return other_recent_courses
    },
    course() {
      const { most_recent_course } = this.recentActivity
      return most_recent_course
    },
    learningPath() {
      return this?.course?.learning_path ?? null
    },
    learningArea() {
      return this?.course?.learning_areas[0]?.name ?? 'INE'
    },
    instructor() {
      return this?.course?.instructors[0]?.name ?? 'INE Instructor'
    },
    isResumingLearningPath() {
      return !!this?.learningPath
    },
    nextUpTypeAndId() {
      return this?.course?.next_content?.content ?? null
    },
    learningPathBackground() {
      if (this?.learningPath?.id) {
        return this.$getPlaylistBackground(this.learningPath?.id)
      }
      return 'https://assets.ine.com/courses/learning+path/LearningPath_background_CCNA_DataCenter.jpg'
    },
    backgroundImageUrl() {
      if (this.learningPath?.id) return this.learningPathBackground
      if (this.course?.id) return this.getCourseBackround(this.course?.id)
      return ''
    },
  },
  methods: {
    updateBilling() {
      this.$router.push({
        name: 'user-dashboard',
        params: {
          mode: 'subscriptions',
        },
      })
    },
    featuredBootcampVisible(value) {
      this.isFeaturedBootcampShown = value
    },
    getCourseBackround(courseId) {
      const breakpoint = this.getBreakpoint()
      const imgSize = getBackgroundSizeBaseOnBreakpoint(breakpoint)
      return this.$getCourseBackground(courseId, imgSize)
    },
  },
  async mounted() {
    await this.$store.dispatch('courses/getActiveCourses')
  },
}
</script>

<style lang="scss">
.subscriber {
  padding: 0 0 60px 0;
  @include tablet {
    padding: 0 0 76px 0;
  }
  &__header {
    position: relative;
    background-size: cover;
    @include mobile {
      margin-bottom: 15px;
    }
    &-overlay {
      height: auto;
      content: '';
      z-index: 0;
      background: linear-gradient(
        to top,
        rgba(21, 21, 21, 0),
        rgba(21, 21, 21, 0),
        rgba(21, 21, 21, 0.3),
        rgba(21, 21, 21, 0.7),
        rgba(21, 21, 21, 1)
      );
      @include mobile {
        background: linear-gradient(
          to bottom,
          rgba(21, 21, 21, 0),
          rgba(21, 21, 21, 0),
          rgba(21, 21, 21, 0.3),
          rgba(21, 21, 21, 0.7),
          rgba(21, 21, 21, 1)
        );
      }
    }
  }
  &-background {
    position: absolute;
    width: 508px;
    height: 509px;
    mix-blend-mode: screen;
    filter: blur(273px);
    transform: matrix(0, -1, -1, 0, 0, 0);
    z-index: -1;
    opacity: 0.4;
    left: 50%;
    transform: translateX(-50%);
    &--1 {
      top: 3200px;
      background: var(--dark-blue);
      @include mobile {
        top: 2600px;
      }
    }
  }
}
.main {
  &__add-a-year-banner {
    .container {
      @include tablet {
        margin-top: 100px;
      }
    }
    .navbar-app {
      @include tablet {
        margin-top: 100px;
      }
    }
  }
}
</style>
